import React from 'react';
import { Link } from 'react-router-dom';
import platformImage from '../assests/main image.png';

const productFeatures = [
  'Multi-tenant WhatsApp management', 'WhatsApp Business API integration',
  'Message and template APIs', 'Media messaging', 'Webhooks and event handling',
  'Campaign and broadcast management', 'Customer communication', 'CRM integration',
  'Automated notifications', 'Appointment messaging', 'Developer APIs',
  'Scalable backend architecture',
];
const tenantData = [
  'Business account', 'WhatsApp Business Account', 'Phone number', 'Templates',
  'Customers', 'Leads', 'Campaigns', 'Message history',
  'Automation workflows', 'API credentials and configuration',
];
const messagingUseCases = [
  'Customer communication', 'Transactional updates', 'Support notifications',
  'Appointment reminders', 'Order updates', 'Account notifications', 'Business alerts',
];
const templateManagement = ['Template names', 'Template categories', 'Languages', 'Variables', 'Approval status', 'Template content', 'Template identifiers'];
const mediaTypes = ['Images', 'Videos', 'Documents', 'Audio', 'Text messages', 'Template messages'];
const webhookUses = [
  'Update message status', 'Track delivery', 'Track read status',
  'Process incoming messages', 'Update CRM records', 'Trigger automation',
  'Notify users', 'Synchronize communication data',
];
const crmEntities = ['Customers', 'Leads', 'Contacts', 'Sales pipelines', 'Appointments', 'Support tickets', 'Campaigns', 'Customer segments'];
const campaignFeatures = ['Contact selection', 'Audience segmentation', 'Template selection', 'Variable substitution', 'Scheduling', 'Campaign logs', 'Delivery tracking'];
const whiteLabelFeatures = [
  ['Customer Dashboard', 'Let customers manage WhatsApp communication from your application.'],
  ['WhatsApp Account Management', 'Provide account connection and configuration workflows.'],
  ['Messaging', 'Offer messaging functionality inside your SaaS dashboard.'],
  ['Templates', 'Let customers manage approved message templates.'],
  ['Campaigns', 'Provide campaign creation and scheduling workflows.'],
  ['CRM', 'Connect WhatsApp conversations with customer records.'],
  ['Automation', 'Trigger WhatsApp messages from events inside your SaaS platform.'],
];
const requirements = [
  ['Customer notifications', 'Send WhatsApp updates to customers.'],
  ['Appointment system', 'Send reminders and booking confirmations.'],
  ['CRM', 'Connect customer communication.'],
  ['E-commerce', 'Send order updates.'],
  ['Support platform', 'Connect customer messaging to support workflows.'],
  ['Marketing platform', 'Build campaign workflows.'],
  ['ERP', 'Send business notifications.'],
  ['Booking software', 'Send booking confirmations.'],
  ['Education SaaS', 'Support school and parent communication.'],
  ['Healthcare software', 'Support appointment communication, subject to privacy and messaging requirements.'],
];
const technologyStack = ['Node.js', 'Express.js', 'PHP', 'Laravel', 'CodeIgniter', 'React', 'Next.js', 'Vue', 'Angular', 'MongoDB', 'MySQL', 'PostgreSQL', 'REST APIs'];
const workflowSteps = [
  ['SaaS Customer Registration', 'A business creates an account on your SaaS platform.'],
  ['WhatsApp Connection', 'The business connects its WhatsApp Business setup.'],
  ['Configuration', 'Your SaaS platform stores the required configuration and account information.'],
  ['Template Setup', 'The business creates or manages approved WhatsApp templates.'],
  ['API Integration', 'Your SaaS backend sends supported messaging requests through the API layer.'],
  ['Message Processing', 'WhatsApp communication is processed and delivered to the intended customer.'],
  ['Webhook Events', 'Message and delivery events are received and processed by your application.'],
  ['Customer Experience', 'The SaaS user can view communication activity from your platform.'],
];
const productUseCases = [
  ['CRM SaaS', 'Add WhatsApp communication to the CRM and manage messaging alongside customer records.'],
  ['E-commerce SaaS', 'Send order confirmations, shipping updates, customer notifications, and other supported messages.'],
  ['Appointment SaaS', 'Send booking confirmations, reminders, and service notifications.'],
  ['Marketing SaaS', 'Create campaign workflows using approved templates and customer audiences.'],
  ['Helpdesk SaaS', 'Connect customer communication with support workflows.'],
  ['ERP SaaS', 'Send business and operational notifications.'],
  ['Education SaaS', 'Provide communication tools for schools, institutes, and education businesses.'],
  ['Real Estate SaaS', 'Help agents and businesses communicate with leads and customers.'],
  ['Healthcare SaaS', 'Integrate supported appointment and patient communication while following applicable privacy and messaging requirements.'],
];
const scaleConsiderations = [
  'Tenant isolation', 'Account management', 'API authentication', 'Webhook processing',
  'Message queues', 'Campaign scheduling', 'Logging', 'Error handling',
  'Rate management', 'Database scalability', 'Monitoring',
];
const platformCapabilities = [
  ['Multi-Tenant Architecture', 'Build WhatsApp functionality for multiple SaaS customers.'],
  ['REST API', 'Connect your application backend with WhatsApp functionality through APIs.'],
  ['Template Management', 'Manage supported WhatsApp message templates and their status.'],
  ['Media Messaging', 'Support business communication involving supported media formats.'],
  ['Campaigns', 'Build campaign and broadcast workflows into your SaaS product.'],
  ['Scheduling', 'Create scheduled communication workflows.'],
  ['Webhooks', 'Process message and status events.'],
  ['CRM', 'Connect WhatsApp communication with customer and lead data.'],
  ['Developer Friendly', 'Integrate WhatsApp capabilities into your existing technology stack.'],
];
const faqItems = [
  ['What is WhatsApp API for SaaS?', 'WhatsApp API for SaaS allows software companies to integrate WhatsApp messaging and related communication features into their SaaS applications.'],
  ['Can I integrate WhatsApp into my SaaS application?', 'Yes. A SaaS application can integrate WhatsApp functionality through APIs and supported WhatsApp Business infrastructure.'],
  ['Can HAWKTRION support multiple SaaS customers?', 'HAWKTRION is designed for multi-tenant business messaging use cases, allowing SaaS platforms to manage WhatsApp communication for multiple businesses.'],
  ['Can I build a white-label WhatsApp SaaS platform?', 'You can build your own SaaS application and integrate WhatsApp functionality into your branded product. Branding, onboarding, and WhatsApp account setup capabilities depend on your implementation and applicable WhatsApp and Meta requirements.'],
  ['Can developers integrate HAWKTRION with Node.js?', 'Yes. Your Node.js or Express.js backend can communicate with HAWKTRION through APIs.'],
  ['Can I integrate WhatsApp with my CRM SaaS?', 'Yes. WhatsApp communication can be connected with customer, lead, appointment, and CRM workflows.'],
  ['Can SaaS applications automate WhatsApp messages?', 'Yes. Your SaaS backend can trigger supported WhatsApp messages based on application events, workflows, and business rules.'],
  ['Can I send WhatsApp templates from my SaaS platform?', 'Yes. Your SaaS platform can integrate template functionality and use approved templates where required by WhatsApp policies.'],
  ['Can I receive WhatsApp webhook events?', 'Webhook-based event processing can synchronize supported message and delivery events with your SaaS application.'],
  ['Is HAWKTRION a WhatsApp or Meta product?', 'No. HAWKTRION is an independent software platform. WhatsApp and Meta are separate products and companies, and use of WhatsApp APIs remains subject to applicable Meta and WhatsApp requirements and policies.'],
];

const SectionHeading = ({ eyebrow, title, children }) => (
  <div className="business-api-heading">
    {eyebrow && <div className="sec-label"><span className="sec-label-dot"></span>{eyebrow}</div>}
    <h2>{title}</h2>
    {children && <p>{children}</p>}
  </div>
);

const BulletList = ({ items }) => (
  <ul className="business-api-list">
    {items.map((item) => <li key={item}>{item}</li>)}
  </ul>
);

const CardGrid = ({ items }) => (
  <div className="business-api-grid">
    {items.map(([title, description]) => (
      <article className="business-api-card" key={title}>
        <h3>{title}</h3>
        <p>{description}</p>
      </article>
    ))}
  </div>
);

const Workflow = ({ steps }) => (
  <ol className="business-api-workflow">
    {steps.map((step, index) => (
      <li key={step}><span className="business-api-step-number">{index + 1}</span><span>{step}</span></li>
    ))}
  </ol>
);

const WhatsappApiForSaasContent = () => (
  <div className="business-api-content saas-api-content">
    <section className="business-api-section business-api-intro">
      <div className="container">
        <div className="business-api-intro-grid">
          <div className="business-api-intro-copy">
            <p className="business-api-lead">Build WhatsApp messaging into your SaaS product with HAWKTRION.</p>
            <p>Connect customer WhatsApp Business Accounts, manage messaging APIs, send templates and media, automate notifications, run campaigns, and build scalable WhatsApp communication features directly into your SaaS platform.</p>
            <p className="saas-api-emphasis">Build your WhatsApp-powered SaaS solution with HAWKTRION.</p>
            <div className="business-api-actions">
              <Link to="/signup" className="btn btn-p">Get Started</Link>
              <Link to="/whatsapp-api-documentation/" className="btn btn-s">Explore API Documentation</Link>
            </div>
          </div>
          <figure className="business-api-visual">
            <img src={platformImage} alt="HAWKTRION WhatsApp platform overview with APIs, CRM, campaigns, automation, and messaging" />
            <figcaption>Add messaging and customer communication workflows to your SaaS product.</figcaption>
          </figure>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="SaaS Platform" title="Turn Your SaaS Product Into a WhatsApp-Powered Platform">
          WhatsApp is an important communication channel for businesses, customers, and teams. If you operate a SaaS platform, CRM, marketing application, appointment system, ecommerce solution, or business management software, integrating WhatsApp can make your product more useful.
        </SectionHeading>
        <p className="business-api-copy">HAWKTRION provides infrastructure to build WhatsApp communication features into your SaaS application. Connect WhatsApp Business Accounts, manage messaging, send approved templates, process media, automate communication, and provide WhatsApp-powered workflows to customers.</p>
        <h3 className="business-api-subheading">Build WhatsApp Into Your Product</h3>
        <BulletList items={productFeatures} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="API for Software" title="What Is a WhatsApp API for SaaS?">
          A WhatsApp API for SaaS allows software companies to integrate WhatsApp communication directly into their applications. Instead of asking customers to manage WhatsApp separately, your SaaS can provide WhatsApp-powered functionality as part of its own platform.
        </SectionHeading>
        <p className="business-api-copy">For example, a CRM SaaS application could let customers connect their WhatsApp Business Account, manage templates, send messages from a dashboard, receive events through webhooks, manage customers and conversations, automate notifications, run campaigns, and track messaging activity.</p>
        <p className="business-api-copy">HAWKTRION helps SaaS businesses build these capabilities into their products.</p>
        <div className="business-api-example">
          <div className="business-api-example-event">
            <span className="business-api-example-label">SAAS APPLICATION EVENT</span>
            <strong>appointment.created</strong>
            <p>Booking confirmed in your product.</p>
          </div>
          <div className="business-api-example-arrow" aria-hidden="true">→</div>
          <div className="business-api-example-chat">
            <div className="business-api-example-chat-head">
              <span className="business-api-chat-avatar">S</span>
              <span><strong>Your SaaS Product</strong><small>WhatsApp Business</small></span>
              <span className="business-api-chat-status">Delivered</span>
            </div>
            <p className="business-api-chat-bubble">Your appointment is confirmed. We&apos;ll send a reminder before your scheduled time.</p>
            <p className="business-api-chat-meta">Template: appointment_confirmation · just now</p>
          </div>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Multi-Tenant Design" title="Build Multi-Tenant WhatsApp Features">
          SaaS applications commonly serve multiple businesses from one platform. Each customer may have its own WhatsApp account, configuration, and communication data.
        </SectionHeading>
        <BulletList items={tenantData} />
        <p className="business-api-copy">HAWKTRION can serve as a WhatsApp communication layer for this kind of SaaS architecture. Design tenant isolation so each business&apos;s records, messaging configuration, and account data remain separated. WhatsApp becomes a native communication feature of your product rather than a separate external workflow.</p>
        <h3 className="business-api-subheading">One Platform, Multiple Business Accounts</h3>
        <p className="business-api-copy">Your SaaS application can provide WhatsApp functionality to different customers while maintaining separation between their business data and messaging configuration.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Product Capabilities" title="WhatsApp API Features for SaaS" />
        <div className="business-api-feature-grid">
          <article className="business-api-card">
            <h3>WhatsApp Messaging API</h3>
            <p>Build messaging directly into your application for customer communication, transactional updates, support notifications, appointment reminders, order updates, account notifications, and business alerts.</p>
            <BulletList items={messagingUseCases} />
          </article>
          <article className="business-api-card">
            <h3>WhatsApp Template Management</h3>
            <p>Provide template management functionality to customers who need approved WhatsApp templates for business-initiated communication.</p>
            <BulletList items={templateManagement} />
          </article>
          <article className="business-api-card">
            <h3>WhatsApp Media Messaging</h3>
            <p>Build support for media-based communication into your SaaS platform, subject to supported WhatsApp API capabilities.</p>
            <BulletList items={mediaTypes} />
          </article>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Automation" title="WhatsApp Automation for SaaS">
          Automation can turn your SaaS product into a customer communication platform. Trigger WhatsApp communication based on application events.
        </SectionHeading>
        <div className="saas-api-event-examples">
          <article><span>ORDER COMPLETE</span><strong>SaaS event → backend → WhatsApp API → customer</strong></article>
          <article><span>APPOINTMENT BOOKED</span><strong>Appointment created → automation → WhatsApp template → customer</strong></article>
          <article><span>PAYMENT CHANGED</span><strong>Payment update → webhook/event → WhatsApp notification</strong></article>
        </div>
        <p className="business-api-copy">This lets your SaaS platform use WhatsApp as part of its existing business workflows.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Real-Time Events" title="WhatsApp Webhooks for SaaS Applications">
          Webhooks let your application respond to supported WhatsApp events, including message status updates and incoming communication.
        </SectionHeading>
        <BulletList items={webhookUses} />
        <p className="business-api-copy">HAWKTRION can act as the communication layer between your SaaS backend and WhatsApp infrastructure.</p>
        <Workflow steps={['Your SaaS backend', 'HAWKTRION WhatsApp API layer', 'WhatsApp Business / Cloud API', 'Customer']} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="CRM & Customer Data" title="Add WhatsApp CRM Features to Your SaaS">
          Connect WhatsApp communication with the customer information your users already manage in your product.
        </SectionHeading>
        <BulletList items={crmEntities} />
        <p className="business-api-copy">Users can manage business communication from the same SaaS environment they use to manage customers.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Customer Campaigns" title="WhatsApp Campaigns for SaaS Customers">
          Give SaaS customers tools to communicate with their audiences through WhatsApp, following applicable WhatsApp policies.
        </SectionHeading>
        <BulletList items={['Promotional communication', 'Customer updates', 'Event notifications', 'Product announcements', 'Appointment reminders', 'Service updates', 'Re-engagement campaigns']} />
        <h3 className="business-api-subheading">Campaign Functionality Can Include</h3>
        <BulletList items={campaignFeatures} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="White Label Options" title="Build a White-Label WhatsApp SaaS Solution">
          Build your own branded dashboard while using HAWKTRION as part of the underlying WhatsApp infrastructure. Branding, onboarding, and account-connection capabilities depend on your implementation and applicable WhatsApp and Meta requirements.
        </SectionHeading>
        <CardGrid items={whiteLabelFeatures} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Why Add WhatsApp?" title="Why SaaS Companies Use WhatsApp APIs" />
        <div className="cloud-api-table-wrap">
          <table className="cloud-api-table">
            <caption>SaaS requirements and example WhatsApp integrations</caption>
            <thead><tr><th scope="col">SaaS Requirement</th><th scope="col">WhatsApp Integration</th></tr></thead>
            <tbody>{requirements.map(([requirement, integration]) => <tr key={requirement}><th scope="row">{requirement}</th><td>{integration}</td></tr>)}</tbody>
          </table>
        </div>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Architecture" title="WhatsApp API for SaaS Developers">
          Integrate HAWKTRION into your existing SaaS architecture while keeping your application&apos;s business logic in your own backend.
        </SectionHeading>
        <Workflow steps={['Your SaaS frontend', 'Your SaaS backend', 'HAWKTRION WhatsApp API layer', 'WhatsApp Business / Cloud API', 'Customer']} />
        <p className="business-api-copy">Your application keeps its existing business logic while using a dedicated WhatsApp communication layer.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Technology Stack" title="Integrate WhatsApp With Your Existing SaaS">
          HAWKTRION can be integrated with applications built using different technology stacks. Your backend can communicate with the HAWKTRION API.
        </SectionHeading>
        <BulletList items={technologyStack} />
        <Link to="/whatsapp-api-documentation/" className="business-api-text-link">Explore API Documentation</Link>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Implementation" title="Create Your Own WhatsApp SaaS Workflow" />
        <ol className="business-api-steps">
          {workflowSteps.map(([title, description], index) => (
            <li className="business-api-step" key={title}>
              <span className="business-api-step-number">{index + 1}</span>
              <div><h3>{title}</h3><p>{description}</p></div>
            </li>
          ))}
        </ol>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="SaaS Use Cases" title="Use Cases for WhatsApp SaaS Platforms" />
        <CardGrid items={productUseCases} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="For Startups" title="HAWKTRION for SaaS Startups">
          You do not need to build every WhatsApp infrastructure component from scratch. HAWKTRION can help your development team focus on the SaaS product while integrating WhatsApp communication into your existing architecture.
        </SectionHeading>
        <BulletList items={['WhatsApp messaging', 'Template management', 'Campaigns', 'Customer communication', 'Notifications', 'CRM workflows', 'Webhooks', 'API integrations', 'Media messaging', 'Message status tracking']} />
        <p className="business-api-copy">Build around your core business logic and add WhatsApp as an integrated communication channel.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Scale & Reliability" title="Scale WhatsApp Communication With Your SaaS">
          As your SaaS customer base grows, your integration needs to support more accounts, messages, and workflows. Plan for:
        </SectionHeading>
        <BulletList items={scaleConsiderations} />
        <p className="business-api-copy">HAWKTRION provides a foundation for WhatsApp-powered SaaS functionality while your application maintains its business logic.</p>
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="HAWKTRION Capabilities" title="WhatsApp API for SaaS Platforms">
          HAWKTRION is built around business messaging and API integration.
        </SectionHeading>
        <CardGrid items={platformCapabilities} />
      </div>
    </section>

    <section className="business-api-section">
      <div className="container">
        <SectionHeading eyebrow="Product Ideas" title="Build a WhatsApp-Powered SaaS Product" />
        <div className="saas-api-pair-grid">
          {['CRM + WhatsApp', 'Marketing + WhatsApp', 'Appointments + WhatsApp', 'E-commerce + WhatsApp', 'Support + WhatsApp', 'Automation + WhatsApp', 'Notifications + WhatsApp', 'SaaS + WhatsApp'].map((item) => <div className="saas-api-pair" key={item}>{item}</div>)}
        </div>
        <p className="business-api-copy">Turn WhatsApp communication into a native feature of your software platform.</p>
      </div>
    </section>

    <section className="business-api-section business-api-faq" id="whatsapp-saas-faq">
      <div className="container">
        <SectionHeading eyebrow="Answers" title="WhatsApp API for SaaS FAQs" />
        <div className="business-api-faq-list">
          {faqItems.map(([question, answer]) => <details key={question}><summary>{question}</summary><p>{answer}</p></details>)}
        </div>
      </div>
    </section>

    <section className="business-api-section business-api-final-cta">
      <div className="container">
        <div className="business-api-cta-panel">
          <SectionHeading eyebrow="Ready to Build?" title="Build Your WhatsApp SaaS With HAWKTRION">
            Add WhatsApp communication to your SaaS product without making it a separate customer workflow. Build, integrate, and automate WhatsApp-powered communication for your customers.
          </SectionHeading>
          <div className="business-api-actions">
            <Link to="/signup" className="btn btn-p">Get Started</Link>
            <Link to="/whatsapp-api-documentation/" className="btn btn-s">View API Documentation</Link>
            <a href="mailto:support@hawktrion.com?subject=WhatsApp%20SaaS%20Integration" className="btn btn-s">Contact HAWKTRION</a>
          </div>
        </div>
       
      </div>
    </section>
  </div>
);

export default WhatsappApiForSaasContent;